import 'swiper/css';

import React, { useEffect, useMemo, useState } from 'react';
import { find, flatten, map, noop } from 'lodash';
import Image from 'next/future/image';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';

import { FreeMode, Thumbs } from 'swiper';
import { useProductState } from '../../store';
import clsx from 'clsx';
import { ArrowLeftIcon, ArrowRightIcon, XIcon } from '@heroicons/react/solid';
import Modal from './Modal';

const Gallery = () => {
  const { product, color } = useProductState();

  const [activeIndex, setActiveIndex] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperClass | null>(null);

  const gallery = useMemo(() => {
    const images = map(
      flatten(
        find(product.colors, ({ color_code }) => color_code === color)?.images
      ),
      src => ({ type: 'image', src })
    );
    return images;
    // return product.video
    //   ? [
    //       ...images.slice(0, 1),
    //       { type: 'video', src: product.video },
    //       ...images.slice(1)
    //     ]
    //   : images;
  }, [product, color]);

  useEffect(() => {
    setActiveIndex(0);
  }, [isModalOpen]);

  function toggleModalOpen() {
    setModalOpen(isModalOpen => !isModalOpen);
  }

  const _thumbsSwiper =
    thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null;

  return (
    <div className="min-w-0 space-y-3 -mx-6 lg:mx-0">
      <div className="relative">
        <Modal isOpen={isModalOpen} toggleOpen={toggleModalOpen}>
          <button
            onClick={toggleModalOpen}
            className={clsx(
              'absolute z-20 top-3 right-3 bg-white rounded-full p-3 shadow md:top-6 md:right-6',
              { hidden: !isModalOpen }
            )}
          >
            <XIcon className="w-6 h-6 cursor-pointer" />
          </button>

          <button
            onClick={() => swiper?.slidePrev()}
            className={clsx(
              'absolute z-20 top-[50%] -translate-y-[50%] left-3 bg-white rounded-full p-3 shadow md:left-6',
              { hidden: activeIndex === 0 }
            )}
          >
            <ArrowLeftIcon className="w-6 h-6 cursor-pointer" />
          </button>

          <button
            onClick={() => swiper?.slideNext()}
            className={clsx(
              'absolute z-20 top-[50%] -translate-y-[50%] right-3 bg-white rounded-full p-3 shadow md:right-6',
              { hidden: activeIndex === gallery.length - 1 }
            )}
          >
            <ArrowRightIcon className="w-6 h-6 cursor-pointer" />
          </button>

          <Swiper
            wrapperTag="ul"
            slidesPerView="auto"
            onSwiper={setSwiper}
            modules={[Thumbs, FreeMode]}
            thumbs={{ swiper: _thumbsSwiper }}
            onSlideChange={element => setActiveIndex(element.realIndex)}
          >
            {gallery.map((media, idx) => (
              <SwiperSlide
                key={idx}
                tag="li"
                onClick={isModalOpen ? noop : toggleModalOpen}
                className="flex justify-center cursor-grab active:cursor-grabbing"
              >
                {media.type === 'image' ? (
                  <img
                    alt="Product preview"
                    src={media.src}
                    className="w-full h-auto object-contain"
                  />
                ) : (
                  // <Image
                  //   alt="Product preview"
                  //   src={media.src}
                  //   width={0}
                  //   height={0}
                  //   sizes="100vw"
                  //   priority
                  //   className="w-full h-auto object-contain"
                  // />
                  <video
                    loop
                    muted
                    autoPlay
                    src={media.src}
                    className="w-full h-full object-cover object-center"
                  />
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </Modal>
      </div>

      <Swiper
        freeMode={true}
        wrapperTag="ul"
        spaceBetween={8}
        slidesPerView={5}
        onSwiper={setThumbsSwiper}
        watchSlidesProgress={true}
        modules={[Thumbs, FreeMode]}
        className="max-w-[80%] mx-auto hidden xl:block"
      >
        {gallery.map((media, idx) => (
          <SwiperSlide
            key={idx}
            tag="li"
            className="cursor-pointer active:cursor-grab"
          >
            {media.type === 'image' ? (
              <img
                alt="Product thumb"
                src={media.src}
                className="w-full h-auto object-contain"
              />
            ) : (
              // <Image
              //   alt="Product thumb"
              //   src={media.src}
              //   width={0}
              //   height={0}
              //   sizes="100vw"
              //   priority
              //   className="w-full h-auto object-contain"
              // />
              <video src={media.src} className="w-full h-auto object-contain" />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Gallery;
